import { render, staticRenderFns } from "./MBTI.vue?vue&type=template&id=71161f90&scoped=true&"
import script from "./MBTI.vue?vue&type=script&lang=js&"
export * from "./MBTI.vue?vue&type=script&lang=js&"
import style0 from "./MBTI.vue?vue&type=style&index=0&id=71161f90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71161f90",
  null
  
)

export default component.exports